module.exports = __webpack_public_path__ + "fa-brands-400.woff?8270e503193150ebf94304681b327961";